<template lang="pug">
div.panel-header
  div.header.text-center
    h2.title Alpha as a Service
    p.category
      | Get info when new tokens are launched or LP provided!
</template>

<script>
export default {};
</script>

<style scoped>
.category {
  text-transform: inherit;
}
</style>
